document.addEventListener('DOMContentLoaded',()=>{
    new Swiper('.shopify-section--fc-pl .mobile-content',{
        spaceBetween: 10,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            512: {
                slidesPerView: 1.8,
            },
            768: {
                slidesPerView: 2.4
            }
        },
        navigation: {
            nextEl: ".shopify-section--fc-pl .swiper-button-next",
            prevEl: ".shopify-section--fc-pl .swiper-button-prev"
        }
    });
    new Swiper('.shopify-section-image-with-text-slider .image-wrapper',{
        spaceBetween: 30,
        navigation: {
            nextEl: ".shopify-section-image-with-text-slider .swiper-button-next",
            prevEl: ".shopify-section-image-with-text-slider .swiper-button-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            512: {
                slidesPerView: 1.2
            },
            768: {
                slidesPerView: 1.5
            },
            1024: {
                slidesPerView : 3
            },
            
            1440: {
                slidesPerView: 3
            }
        }
    });
    new Swiper('.shopify-section--custom-review .reivew-data-container',{
        slidesPerView:1,
        navigation: {
            nextEl: '.shopify-section--custom-review .swiper-button-next',
            prevEl: '.shopify-section--custom-review .swiper-button-prev'
        }
    });
});